// extracted by mini-css-extract-plugin
module.exports = {"imagePlayIcon":"course-edit-knowledge_imagePlayIcon__rp9nK","cardImageDiv":"course-edit-knowledge_cardImageDiv__2psdi"};